import { Html5Qrcode } from "html5-qrcode";
import { useEffect, useRef } from "react";

export default function ImeiScanner({ onScan, onClose }) {
  const html5QrCodeRef = useRef(null);
  const isRunningRef = useRef(false);

  useEffect(() => {
    const html5QrCode = new Html5Qrcode("imei-camera");
    html5QrCodeRef.current = html5QrCode;

    Html5Qrcode.getCameras()
      .then((devices) => {
        if (!devices || devices.length === 0) {
          console.warn("No cameras found");
          return;
        }

        const backCamera =
          devices.find((d) => d.label.toLowerCase().includes("back")) ||
          devices[0];

        html5QrCode
          .start(
            backCamera.id,
            {
              fps: 10,
              qrbox: { width: 250, height: 120 },
              focusMode: "continuous",
            },
            (decodedText) => {
              const imei = decodedText.replace(/\D/g, "");
              if (imei.length >= 14 && imei.length <= 16) {
                onScan(imei);

                if (isRunningRef.current) {
                  html5QrCode.stop().catch(() => {});
                  isRunningRef.current = false;
                }

                onClose();
              }
            }
          )
          .then(() => {
            isRunningRef.current = true; // ✅ mark started
          })
          .catch((err) => {
            console.error("Camera start failed:", err);
          });
      })
      .catch(console.error);

    return () => {
      if (isRunningRef.current) {
        html5QrCode.stop().catch(() => {});
        isRunningRef.current = false;
      }
    };
  }, [onScan, onClose]);

  const handleCancel = () => {
    if (isRunningRef.current && html5QrCodeRef.current) {
      html5QrCodeRef.current.stop().catch(() => {});
      isRunningRef.current = false;
    }
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center">
      <div className="bg-white rounded-xl p-4 w-[320px]">
        <h3 className="text-sm font-semibold mb-2">Scan IMEI</h3>

        <div
          id="imei-camera"
          className="rounded-lg bg-black"
          style={{ width: "100%", height: "250px" }}
        />

        <button
          onClick={handleCancel}
          className="mt-3 w-full py-2 text-sm bg-slate-200 rounded-lg"
        >
          Cancel
        </button>
      </div>
    </div>
  );
}

